<template>
  <div class="page-container">
    <!-- 头部 -->
    <section>
      <com-header></com-header>
    </section>

    <!-- nav -->
    <section>
      <com-nav></com-nav>
    </section>

    <!-- 内容部分 -->
    <section>
      <div class="page-content">
        <div class="line-mask"></div>
        <div class="page-area">
          <div class="cont-item">
            <p class="font-big title">花丝镶嵌</p>
            <p class="font-middle dec">花丝镶嵌，又称细金工艺，</p>
            <p class="font-middle dec">是一门传承久远的古老中国手工工艺，</p>
            <p class="font-middle dec">主要用于皇家用品的制作，乃“燕京八绝”之一，</p>
            <p class="font-middle dec">
              2008年，花丝镶嵌技艺被正式纳入国家级非物质文化遗产名录。
            </p>
            <div class="img-box">
              <img
                src="http://www.borlandjewel.com/common/1.gif"
                alt=""
              />
            </div>
          </div>
          <div class="cont-item">
            <p class="font-middle dec">
              “花丝为骨，镶嵌作饰”，一件精致华美的花丝镶嵌作品，
            </p>
            <p class="font-middle dec">需要采用直径仅有0.193毫米的金丝，</p>
            <p class="font-middle dec">
              并通过“掐、填、攒、焊、堆、垒、织、编”八大工艺，
            </p>
            <p class="font-middle dec">
              再结合多种复杂工序创作而成；镶嵌以“锉、锼、锤、闷、打、崩、挤、镶”等技法，
            </p>
            <p class="font-middle dec">
              将金属手工打造成托与凹槽，再镶以色泽美丽的宝石。
            </p>
            <div class="img-box">
              <img
                src="http://www.borlandjewel.com/common/2.gif"
                alt=""
              />
            </div>
          </div>
          <div class="cont-item">
            <p class="font-big title">画珐琅技艺</p>
            <p class="font-middle dec">
              “远看似景泰蓝”或许就是画珐琅给人的第一感觉，但二者其实截然不同。
            </p>
            <p class="font-middle dec">画珐琅是古代西域舶来的古法上色技艺，</p>
            <p class="font-middle dec">使用的金丝直径仅0.193毫米，</p>
            <p class="font-middle dec">再经搓丝、花丝造型、镶嵌，使整个作品融为一体，</p>
            <p class="font-middle dec">其复杂程度远远超出想象。</p>
            <div class="img-box">
              <img
                src="http://www.borlandjewel.com/common/3.gif"
                alt=""
              />
            </div>
          </div>
          <div class="cont-item">
            <p class="font-middle dec">
              每件画珐琅作品上色要烧制7遍以上，其中任何一道烧制工序没有把握好，
            </p>
            <p class="font-middle dec">
              都有可能出现崩蓝、釉色脱落、色彩色泽不均匀等状况，最终功亏一篑。
            </p>
            <p class="font-middle dec">相较于景泰蓝，画珐琅各种花丝高于釉面之上，</p>
            <p class="font-middle dec">
              造型更具立体感，以手触之，更具精致细腻与温润之感。
            </p>
            <div class="img-box">
              <img
                src="http://www.borlandjewel.com/common/4.gif"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import comHeader from "../components/comheader.vue";
import comNav from "../components/comnav.vue";
export default {
  name: "craft",
  data() {
    return {};
  },
  components: {
    comHeader: comHeader,
    comNav: comNav,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.page-container {
  width: 100%;
  .page-content {
    position: relative;
    width: 100%;
    background-image: linear-gradient(180deg, #0a0020 0%, #534d63 100%);
    .line-mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      background-image: url("../assets/indexbottomline.png");
      background-repeat: repeat-y;
      background-size: 100% auto;
      background-position: top left;
    }
    .page-area {
      position: relative;
      z-index: 1;
      padding: 220px 0;
      .cont-item {
        margin-bottom: 140px;
        color: #ffffff;
        text-align: center;
        &:last-child {
          margin-bottom: 0;
        }
        .dec {
          font-size: 16px;
          line-height: 80px;
          letter-spacing: 10px;
        }
        .title {
          margin-bottom: 80px;
          letter-spacing: 30px;
        }
        .img-box {
          width: 70%;
          max-width: 800px;
          margin: 70px auto 0 auto;
          cursor: pointer;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/craft.vue